<template>
  <v-row>

    <v-col>
      <v-sheet
        outlined
        v-if="!loading">
        
        <v-img
          class="image-landing"
          height="140"
          :src="require('@/assets/img/jije.png')"
        ></v-img>

        
        <v-row class="pa-6">
          <v-container style="max-width: 75vw;">
            <v-col cols="12">
              <h2 class="pt-8">
                ¡Hola <b>{{ user.name }}!</b>
              </h2>
              <h3 class="pt-8">
                Muchas gracias por registrarte en la {{ edition.edition.name + ' - '+ edition.edition.short_name }}.
              </h3>

              <h3 class="pt-8">
                ¡Te esperamos a partir del {{ handleDate(edition.edition.start_date_public_access) }} 
                para disfrutar de la {{ edition.edition.short_name }}!
              </h3>
              <h3>
                Saludos. <br>
                Equipo JIJE
              </h3>
            </v-col>

            <v-col cols="12" class=" pt-8 text-center"  v-if="!loading">
              <v-btn
                x-large
                class="white--text"
                color="#0097B4"
                @click="changeEdition()">
                Recorrer otra Edición
              </v-btn>
            </v-col>
          </v-container>
        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="change_edition"
      max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Seleccione una edición:</span>
        </v-card-title>
        <v-card-text>

          <v-col cols="12">
            <v-btn 
              v-for="edition in editions"
              :key="edition.id"
              block
              x-large
              dark
              color="#0097B4"
              class="mt-4"
              @click="setEdition(edition)">
              {{ edition.short_name }}
            </v-btn>
          </v-col>
 
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isLoading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <pre>
      {{ user }}
    </pre>
  </v-row>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'

  export default {
    name: 'WaitingRoom',
    data: () => ({
      loading: true,
      loading_get_editions: false,
      dialog:false,
      edition_id:null,
      editions: null,
      slug: null,
      edition2: null,
      change_edition:false,
    }),

    computed: {
      ...mapGetters([ 
      'isLogged','user', 'edition'
      ]),
      isLoading() {
        return this.loading || this.loading_get_editions;
      }
    },

    methods:{
      handleDate(fecha) {
          var partes = fecha.split('-'); // Dividir la fecha en partes [año, mes, día]
          var nuevaFecha = partes[2] + '/' + partes[1] + '/' + partes[0];
          return nuevaFecha;
      },

      async getInfoEdition(){
        await axios.get('edition/'+this.slug+'/slug').then(response => {
          this.edition2 = response.data.data.edition
          if(this.edition2.access_enabled){
            this.logout()
            this.$router.push({ name: 'login' })
          }
          // localStorage.removeItem('user')
          this.loading = false
        }).catch((e)=>{
          console.log(e)
        })
      },

      async changeEdition(){
        this.loading_get_editions = true
        await axios.get('edition').then(response => {
          this.editions = response.data.data.editions
          this.loading_get_editions = false
          this.change_edition = true
        })
      },

      setEdition(e){
        localStorage.removeItem('convocation_form')
        localStorage.removeItem('edition')

        this.$store.dispatch('setDrawer', false);
        this.$store.dispatch('edition', {edition: e })
        if(e.waiting_room){
          this.$router.push({ name: 'WaitingRoom' , params: { slug: e.slug } })
          this.$store.dispatch('setDrawer', true);
        }
        else{
          this.$router.push({ name: "home"})
          this.$store.dispatch('setDrawer', true);
        }
        this.change_edition = false
      }

    },

    created(){
      // this.edition_id= this.$route.params.edition_id;
      this.slug= this.$route.params.slug;
      this.getInfoEdition()
    },
  }
</script>